<phdsoft-sideboard [options]="optionsWindow" (cancel)="close()" class="automatic-plan-type-selector">
  <div content class="bot-insertion-content tw-flex tw-flex-col tw-justify-between tw-h-full">
    <div class="bot-insertion-browser" fxLayout="column">
      <form class="bot-insertion-search-form" [formGroup]="form" fxFlex="100">
        <div class="bot-insertion-search" fxFlex="100">
          <mat-form-field fxFlex="100" class="bot-insertion-search-field" appearance="outline">
            <mat-icon class="search-icon" matPrefix>search</mat-icon>
            <input formControlName="Search" matInput placeholder="Search" type="search" />
            <mat-icon
              class="clear-search"
              *ngIf="form.get('Search')?.value?.length > 0"
              matSuffix
              aria-label="Clear"
              (click)="form.get('Search').setValue('')"
              >close</mat-icon
            >
          </mat-form-field>
        </div>
      </form>

      <mat-accordion class="bot-insertion-type-list">
        <ng-container *ngFor="let item of listInpectionType">
          <mat-expansion-panel class="bot-insertion-type-panel" *ngIf="item?.enableBotInsertion">
            <mat-expansion-panel-header class="bot-insertion-type-header">
              <mat-panel-title class="bot-insertion-type-title" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10">
                <div class="bot-insertion-type-name">{{ item?.name }}</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngFor="let itemChild of item?.listAssociate">
              <div fxLayout="row" fxLayoutAlign="space-between center" class="item-option">
                <button mat-button class="bot-insertion-method" type="button" (click)="openAdvancedConfig(item, itemChild)" fxFlex>
                  {{ itemChild?.name }}
                </button>
                <!-- <button mat-button type="button" (click)="changeType(item, itemChild)" fxFlex>
                  {{ itemChild?.name }}
                </button> -->
                <!-- <button mat-button type="button" (click)="openAdvancedConfig(item, itemChild)" matTooltip="Advanced Configuration">
                  <mat-icon>settings</mat-icon>
                </button> -->
              </div>
            </ng-container>
          </mat-expansion-panel>
        </ng-container>
      </mat-accordion>

      <div class="bot-insertion-browser-state">
        <div *ngIf="notFound === true" class="empty-state">
          <span class="labelNotFound">No type collection found</span>
        </div>
        <div *ngIf="loading" class="searchButton loading-state">
          <i class="loading fa fa-spinner fa-pulse fa-fw fa-2x"></i>
        </div>
      </div>
    </div>

    <phdsoft-inspection-plan-selector
      *ngIf="showPlanSelector"
      [inspectionTypeId]="inspectionTypeId"
      [regionIds]="regionIds"
      (planSelected)="onPlanSelected($event)"
    ></phdsoft-inspection-plan-selector>
  </div>
</phdsoft-sideboard>
